import Navigation from './components/Navigation';
import { HEADER_LABEL_URL_MAP } from './consts';
import { Transition, Dialog } from '@headlessui/react';
import { MAFConnectIcon, MAFIcon, HamburgerIcon } from 'assets/svg';
import React, { Fragment, useState, useMemo, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import useOnClickOutside from 'shared/hooks/useOnClickOutside';
import useScreenWidth from 'shared/hooks/useScreenWidth';
import { routeBuilder } from 'shared/router';
import { redirectLogout } from 'shared/utils/auth';
import { SCREENS } from 'tailwind/consts';

function Header() {
  const location = useLocation();
  const menuContainerRef = useRef(null);

  const screenWidth = useScreenWidth();
  const isMobileMenu = screenWidth < SCREENS.lg;

  const [menuOpen, setMenuOpen] = useState(false);
  const openMenu = () => setMenuOpen(true);
  const closeMenu = () => setMenuOpen(false);

  useOnClickOutside(menuContainerRef, closeMenu);

  const displayedLabel = useMemo(() => {
    const headerEntries = Object.values(HEADER_LABEL_URL_MAP);
    for (const e of headerEntries) {
      if (e?.test && e.test(location.pathname)) {
        return e.label;
      }
    }
    return '';
  }, [location]);

  return (
    <>
      <div className="z-30 fixed left-0 right-0 h-[56px] md:h-[60px] px-4 md:px-10 bg-palette-dark-brown">
        <div className="flex w-full h-full justify-between items-center">
          {isMobileMenu ? (
            <>
              <button onClick={openMenu} className="flex items-center gap-2 text-white">
                <HamburgerIcon className="w-5" />
                <span className="tracking-tight">{displayedLabel}</span>
              </button>
              <div className="flex items-center">
                <MAFIcon className="text-white w-5" />
              </div>
            </>
          ) : (
            <>
              <Link to={routeBuilder.root()} className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                <MAFConnectIcon className="text-white w-32" />
              </Link>
              <button onClick={openMenu} className="flex gap-2 items-center text-white">
                <HamburgerIcon className="w-5" />
                <span className="tracking-tight">{displayedLabel}</span>
              </button>
              <button className="flex group" onClick={redirectLogout}>
                <span className="transition-colors text-white group-hover:text-palette-gold">Logout</span>
              </button>
            </>
          )}
        </div>
      </div>
      <Transition appear={true} show={menuOpen} as={Fragment}>
        <Dialog as="div" className="relative z-30" onClose={closeMenu}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-palette-secondary transition-opacity opacity-20" />
          </Transition.Child>
          <div className="fixed left-0 top-0 bottom-0 w-full md:w-80">
            <div className="flex h-full max-h-full items-center justify-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 -translate-x-full"
                enterTo="opacity-100 translate-x-0"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-x-0"
                leaveTo="opacity-0 -translate-x-full"
              >
                <Dialog.Panel ref={menuContainerRef} className="h-full w-full">
                  <Navigation onClose={closeMenu} onLogout={redirectLogout} />
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}

export default Header;
